import { Button, Result } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

const RestrictedSmartBEA: React.FC = () => {
  const history = useHistory();

  const handleGoToLocations = () => {
    history.push("/locations");
  };

  return (
    <div style={{ padding: "2rem" }}>
      <Result
        status="info"
        title="Access to SmartBEA onboarding is no longer available"
        subTitle="You've already completed SmartBEA onboarding and have at least one location. Please access your SmartBEA dashboard through your location details."
        extra={[
          <Button type="primary" key="locations" onClick={handleGoToLocations}>
            Go to My Locations
          </Button>,
        ]}
      />
    </div>
  );
};

export default RestrictedSmartBEA;
